import * as Yup from 'yup';

const newRegistro = {
    nome: '',
};

const validation = Yup.object().shape({
    nome: Yup.string()
        .min(2, 'O campo deve ter no mínimo 2 caracteres')
        .max(60, 'Campo deve ter menos do que 60 caracteres')
        .required('Este campo é obrigatório'),
});

export const grupoContaAgrareWhiteLabel = {
    newRegistro,
    validation
}